const registrationWithoutPINUniqueIDTooltipTemplate = `
    <div>Your <span>Unique Identifier</span> is your Employee ID, or other identifier as selected by your Company.</div>
`;

export default registrationWithoutPINUniqueIDTooltipTemplate